import SignInForm from '../components/SignInForm';
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../app/hooks';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import ScreenHero from '../components/ScreenHero';
import ScreenFloating from '../components/ScreenFloating';
import combineStyles from '../utils/combineStyles';
import getThemeLookup from '../selectors/getThemeLookup';
import { Redirect } from 'react-router-dom';
import { OrderingSelectors } from 'polygon-ordering';
import { REWARDS_SCREEN_ROUTE } from './RewardsScreen';

const { getMember } = OrderingSelectors;

export const SIGN_IN_ROUTE = '/';

const RegisterScreen: React.FC = () => {
  const p = useAppSelector(getThemeLookup);
  const deviceTypeMobile = useAppSelector(getDeviceTypeMobile);
  const ScreenComponent = deviceTypeMobile ? ScreenHero : ScreenFloating;
  const isOnlyLoyaltyEnabled = useAppSelector(state => state.config.enableOnlyLoyalty);
  const member = useAppSelector(getMember);

  return isOnlyLoyaltyEnabled && member ? (
    <Redirect to={REWARDS_SCREEN_ROUTE} />
  ) : (
    <ScreenComponent>
      <div
        style={combineStyles(
          deviceTypeMobile ? styles.mainContainerMobile : styles.mainContainerDesktop,
          p('screen', ['backgroundColor']),
          p(deviceTypeMobile ? 'initialScreenMobile' : 'initialScreenDesktop', [
            'backgroundColor',
            'boxShadow',
          ]),
        )}
      >
        <SignInForm />
      </div>
    </ScreenComponent>
  );
};

export default RegisterScreen;

const styles = {
  mainContainerDesktop: {
    borderRadius: 2,
    padding: 35,

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',

    margin: 'auto', // https://stackoverflow.com/a/33455342/8706204
  },
  mainContainerMobile: {
    flex: 1,
    padding: '10px 25px 100px 25px',
  },
};
